// Every route of the service-provider area. Use these instead of hardcoded strings
// so the area can move without breaking links.
export const PROVIDER_BASE = '/dashboard/provider';

export const providerPaths = {
  dashboard: PROVIDER_BASE,
  myServices: `${PROVIDER_BASE}/my-services`,
  manageOffers: `${PROVIDER_BASE}/manage-offers`,
  myBookings: `${PROVIDER_BASE}/my-bookings`,
  bookingDetails: (bookingId) => `${PROVIDER_BASE}/booking-details/${bookingId}`,
  settings: `${PROVIDER_BASE}/settings`,
};
